import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { default as TableComponent } from "../../App/Components/Table/Table"
import TableColumn from "../../App/Components/Table/TableColumn";
import Spinner from "../../App/Components/Spinner/Spinner";
import TranslationDataStore from "../DataStore/TranslationDataStore";
import DataStoreDataProvider from "../../App/Components/Table/DataProvider/DataStoreDataProvider";
import {locale} from "moment";

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => ++value); // update the state to force render
}

export default function Translation()
{
    const { t, i18n } = useTranslation();

    const [dataVersion, setDataVersion] = useState(0);
    const increaseVersion = () => setDataVersion(dataVersion + 1);

    const [ dataProvider, setDataProvider ] = useState(null);
    if (null === dataProvider) {
        setDataProvider(new DataStoreDataProvider(TranslationDataStore, 'getTranslations', 'updateTranslation'));

        return  <Spinner/>
    }


    let locales = {'nl': 'Nederlands', 'en': 'English', 'fr': 'Français', 'de': 'Deutsche'};

    let columns = [];
    columns.push(
        <TableColumn dataKey={"key"}
                     editable={false}
                     key={'localeColumnKey'}
        >
            {t(locales[i18n.language])}
        </TableColumn>
    );

    delete locales[i18n.language];
    columns = columns.concat(Object.keys(locales).map((key) => {
        return (
            <TableColumn dataKey={key}
                         editable={true}
                         collapsable={false}
                         sortable={false}
                         key={'localeColumn' + key}
            >
                {locales[key]}
            </TableColumn>
        );
    }))

    return <div>
        <h2>{t('Activity translations')}</h2>
        <a href="/settings/activity-translations" className="button">
            { t('Activities') }
        </a>
        <button className={"button"} onClick={() => { TranslationDataStore.refresh().then(increaseVersion) }}>
            { t('Refresh') }
        </button>
        <TableComponent dataProvider={dataProvider} pageSize={50} version={dataVersion}>
            {columns}
        </TableComponent>
    </div>
};
